export default {"src":"/_next/static/media/shipment.fae7f845.svg","height":15,"width":14};